import { Button, styled } from "@mui/material";

export const ModalButtonStyled = styled(Button)({
  width: "130px",
});
